import { render, staticRenderFns } from "./AdminBuList.vue?vue&type=template&id=9c248690&lang=pug"
import script from "./AdminBuList.vue?vue&type=script&lang=js"
export * from "./AdminBuList.vue?vue&type=script&lang=js"
import style0 from "./AdminBuList.vue?vue&type=style&index=0&id=9c248690&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports